export const clearStorage = () => localStorage.clear();

export const setObject = (key: string, value: string | object | any[]) => (
  localStorage.setItem(key, JSON.stringify(value))
);

export const getObject = (key: string) => {
  const item = localStorage.getItem(key);

  if (!item) {
    return null;
  }

  return JSON.parse(item);
};
